<template>
  <div class="vehicle-guarantee-tab">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-select
        v-model="searchForm.vehicleId"
        placeholder="请选择车辆"
        style="width: 200px; margin-right: 10px"
        clearable
        filterable
      >
        <el-option
          v-for="vehicle in vehicleList"
          :key="vehicle.vehicleId"
          :label="`${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`"
          :value="vehicle.vehicleId"
        />
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
      <el-button type="success" @click="handleAdd">新增</el-button>
    </div>
    
    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="guaranteeId" label="保障ID" width="150" />
      <el-table-column prop="vehicleId" label="车辆" width="200">
        <template slot-scope="scope">
          <span>{{ getVehicleDisplayName(scope.row.vehicleId) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reportIssueDate" label="报告出具日" width="120" />
      <el-table-column prop="guaranteeExpireDate" label="保障到期日" width="120" />
      <el-table-column prop="guaranteeType" label="保障类型" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.guaranteeType === 'standard'" type="primary">标准</el-tag>
          <el-tag v-else-if="scope.row.guaranteeType === 'premium'" type="success">高级</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="guaranteeStatus" label="保障状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.guaranteeStatus === 'active'" type="success">激活</el-tag>
          <el-tag v-else-if="scope.row.guaranteeStatus === 'inactive'" type="warning">未激活</el-tag>
          <el-tag v-else-if="scope.row.guaranteeStatus === 'expired'" type="danger">已过期</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="guaranteeDays" label="保障天数" width="100" />
      <el-table-column prop="activationDate" label="激活日期" width="120" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px; text-align: right"
    />
    
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="车辆" prop="vehicleId">
          <el-select v-model="form.vehicleId" placeholder="请选择车辆" style="width: 100%" clearable>
            <el-option
              v-for="vehicle in vehicleList"
              :key="vehicle.vehicleId"
              :label="`${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`"
              :value="vehicle.vehicleId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="报告出具日" prop="reportIssueDate">
          <el-date-picker
            v-model="form.reportIssueDate"
            type="date"
            placeholder="选择报告出具日"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="保障到期日" prop="guaranteeExpireDate">
          <el-date-picker
            v-model="form.guaranteeExpireDate"
            type="date"
            placeholder="选择保障到期日"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="保障类型" prop="guaranteeType">
          <el-select v-model="form.guaranteeType" placeholder="请选择保障类型" style="width: 100%">
            <el-option label="标准" value="standard" />
            <el-option label="高级" value="premium" />
          </el-select>
        </el-form-item>
        <el-form-item label="保障状态" prop="guaranteeStatus">
          <el-select v-model="form.guaranteeStatus" placeholder="请选择保障状态" style="width: 100%">
            <el-option label="激活" value="active" />
            <el-option label="未激活" value="inactive" />
            <el-option label="已过期" value="expired" />
          </el-select>
        </el-form-item>
        <el-form-item label="激活日期" prop="activationDate">
          <el-date-picker
            v-model="form.activationDate"
            type="date"
            placeholder="选择激活日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="保障天数" prop="guaranteeDays">
          <el-input-number v-model="form.guaranteeDays" :min="1" :max="365" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getVehicleGuaranteeList, addVehicleGuarantee, updateVehicleGuarantee, deleteVehicleGuarantee } from '@/api/guarantee'
import request from '@/utils/request'

export default {
  name: 'VehicleGuaranteeTab',
  data() {
    return {
      searchForm: {
        vehicleId: ''
      },
      vehicleList: [],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增车辆保障信息',
      form: {
        vehicleId: '',
        reportIssueDate: '',
        guaranteeExpireDate: '',
        guaranteeType: 'standard',
        guaranteeStatus: 'inactive',
        activationDate: '',
        guaranteeDays: 90
      },
      rules: {
        vehicleId: [
          { required: true, message: '请输入车辆ID', trigger: 'blur' }
        ],
        reportIssueDate: [
          { required: true, message: '请选择报告出具日', trigger: 'change' }
        ],
        guaranteeExpireDate: [
          { required: true, message: '请选择保障到期日', trigger: 'change' }
        ],
        guaranteeType: [
          { required: true, message: '请选择保障类型', trigger: 'change' }
        ],
        guaranteeStatus: [
          { required: true, message: '请选择保障状态', trigger: 'change' }
        ],
        guaranteeDays: [
          { required: true, message: '请输入保障天数', trigger: 'blur' }
        ]
      },
      isEdit: false,
      editId: null
    }
  },
  mounted() {
    this.loadVehicleList()
    this.loadData()
  },
  methods: {
    // 加载数据
    async loadData() {
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          vehicleId: this.searchForm.vehicleId
        }
        const response = await getVehicleGuaranteeList(params)
        if (response.code === '200') {
          this.tableData = response.data.records
          this.pagination.total = response.data.total
        } else {
          this.$message.error(response.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm.vehicleId = ''
      this.pagination.current = 1
      this.loadData()
    },
    
    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增车辆保障信息'
      this.form = {
        vehicleId: '',
        reportIssueDate: '',
        guaranteeExpireDate: '',
        guaranteeType: 'standard',
        guaranteeStatus: 'inactive',
        activationDate: '',
        guaranteeDays: 90
      }
      this.dialogVisible = true
    },
    
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑车辆保障信息'
      
      // 处理日期字段，将字符串转换为Date对象
      const formData = { ...row }
      if (formData.reportIssueDate && typeof formData.reportIssueDate === 'string') {
        formData.reportIssueDate = new Date(formData.reportIssueDate)
      }
      if (formData.guaranteeExpireDate && typeof formData.guaranteeExpireDate === 'string') {
        formData.guaranteeExpireDate = new Date(formData.guaranteeExpireDate)
      }
      if (formData.activationDate && typeof formData.activationDate === 'string') {
        formData.activationDate = new Date(formData.activationDate)
      }
      
      this.form = formData
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该车辆保障信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteVehicleGuarantee(row.id)
          if (response.code === '200') {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('网络错误，请重试')
        }
      })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            // 格式化日期字段
            const submitData = { ...this.form }
            
            // 格式化报告出具日
            if (submitData.reportIssueDate) {
              if (submitData.reportIssueDate instanceof Date) {
                submitData.reportIssueDate = this.formatDate(submitData.reportIssueDate)
              }
            }
            
            // 格式化保障到期日
            if (submitData.guaranteeExpireDate) {
              if (submitData.guaranteeExpireDate instanceof Date) {
                submitData.guaranteeExpireDate = this.formatDate(submitData.guaranteeExpireDate)
              }
            }
            
            // 格式化激活日期
            if (submitData.activationDate) {
              if (submitData.activationDate instanceof Date) {
                submitData.activationDate = this.formatDate(submitData.activationDate)
              }
            }
            
            let response
            if (this.isEdit) {
              response = await updateVehicleGuarantee(submitData)
            } else {
              response = await addVehicleGuarantee(submitData)
            }
            
            if (response.code === '200') {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(response.msg || (this.isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('网络错误，请重试')
          }
        }
      })
    },
    
    // 格式化日期为 yyyy-MM-dd 格式
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadData()
    },
    
    // 加载车辆列表
    async loadVehicleList() {
      try {
        const response = await request.get('/api/admin/guarantee/vehicle/options')
        if (response.code === '200') {
          this.vehicleList = response.data
        } else {
          this.$message.error(response.msg || '获取车辆列表失败')
        }
      } catch (error) {
        console.error('加载车辆列表失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 获取车辆显示名称
    getVehicleDisplayName(vehicleId) {
      const vehicle = this.vehicleList.find(v => v.vehicleId === vehicleId)
      if (vehicle) {
        return `${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`
      }
      return vehicleId
    }
  }
}
</script>

<style scoped>
.vehicle-guarantee-tab {
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
}
</style> 